import { Box, Grid, SxProps, Theme, Typography } from '@mui/material';
import kung8 from '../images/kung8.png';
import kung12 from '../images/kung12.png';
import kung13 from '../images/kung13.png';
import video8 from '../images/video_8.jpeg';
import video12 from '../images/video_12.jpeg';
import video13 from '../images/video_13.jpeg';
import mrvegas8 from '../images/mrvegas_8_big.jpeg';
import mrvegas12 from '../images/mrvegas_12_big.jpeg';
import mrvegas13 from '../images/mrvegas_13_big.jpeg';
import mega8 from '../images/mega_8.png';
import mega12 from '../images/mega_12.png';
import mega13 from '../images/mega_13.png';
import comeon8 from '../images/comeon_8.png';
import comeon12 from '../images/comeon_12.png';
import comeon13 from '../images/comeon_13.png';
import comeon7 from '../images/comeon_7.png';
import comeon9 from '../images/comeon_9.png';
import snabbare8 from '../images/snabbare_8.png';
import snabbare7 from '../images/snabbare_7.png';
import snabbare9 from '../images/snabbare_9.png';
import snabbare12 from '../images/snabbare_12.png';
import snabbare13 from '../images/snabbare_13.png';
import reviantBg from '../images/reviant.png';
import woodRocket from '../images/wood_rocket.png';
import orangeRocket from '../images/orange_rocket.png';
import lionRocket from '../images/lion_rocket.png';
import hajper8 from '../images/hajper_8.png';
import hajper12 from '../images/hajper_12.png';
import hajper13 from '../images/hajper_13.png';
import stugan7 from '../images/stugan_7.png';
import stugan9 from '../images/stugan_9.png';
import stugan8 from '../images/stugan_8.png';
import stugan12 from '../images/stugan_12.png';
import stugan13 from '../images/stugan_13.png';
import stuganSurvivor6 from '../images/stugan_survivor6.png';
import stuganSurvivor8 from '../images/stugan_survivor8.png';
import snabbareSurvivor6 from '../images/snabbare_survivor_6.png';
import snabbareSurvivor8 from '../images/snabbare_survivor_8.png';
import hard13 from '../images/hard_13.png';
import hard12 from '../images/hard_12.png';
import hard8 from '../images/hard_8.png';
import hard9 from '../images/hard_hockey_9.png';
import hardSurvivor from '../images/hard_survivor_65.png';
import unibet_football from '../images/unibet_football.jpg';
import unibet_hockey from '../images/unibet_hockey.png';
import { Unibet1x2Logo } from '../images/unibeticons';
import { GetFlexNumber, GetMixMaxFlex, gradientsC, IsLeo, IsOrangeLight, IsVideo, productNamesC, themeC } from "../theme/themehelper";
import { setOrigin, track } from "../analytics/analytics";
import { DbetEightIcon, DbetEightLadder, DbetHockeyNineLogo, DbetSevenIcon, DbetSixIcon, DbetThirteenIcon, DbetThirteenLadder, DbetTwelveIcon, DbetTwelveLadder } from "../images/dbeticons";
import { ReactNode } from "react";
import { ShallowRound } from "../models/round";
import RoundBoxContent from "./roundboxcontent";
import { isTheGameRoundName } from "../roundview/components/thegame/thegamemanifest";

interface RoundBoxWithButtonProps {
    round: ShallowRound;
    t: (key: string) => string;
    children?: ReactNode;
    // Replaces the product name and number in the header.
    title?: string;
}

function RoundBoxWithButton({ round, t, children, title }: RoundBoxWithButtonProps) {    

    let theme = window.theme;

    let logoSize: string = 'cover';
    let logoPosition: string = 'center';

    let smallText: SxProps<Theme> = {
        fontSize: "14px",
        lineHeight: "21px",
        color: 'var(--font-color-supportive)',
        fontWeight: "400",
        fontFamily: 'var(--font-title)'
    };

    let smallTitle: SxProps<Theme> = {
        fontSize: "16px",
        color: 'var(--text-black)',
        lineHeight: "20px",
        fontWeight: "700",
        fontFamily: 'var(--font-title)',
    };

    let smallTitleUpper: SxProps<Theme> = {
        fontSize: "16px",
        color: 'var(--text-black)',
        lineHeight: "20px",
        fontWeight: "700",
        fontFamily: 'var(--font-title)',
        textTransform: 'uppercase'
    };

    let mixMaxFlexStyle: SxProps<Theme> = {
        fontSize: "25px",
        fontFamily: 'var(--font-title)',
        color: 'var(--text-white)',
        fontWeight: "400",
        textTransform: "uppercase",
        marginTop: "20px"
    };

    let mixMaxFlexNumberStyle: SxProps<Theme> = {
        fontSize: "80px",
        fontFamily: 'var(--font-title)',
        color: 'var(--text-white)',
        fontWeight: "800",
        marginTop: "-25px"
    };

    let jackpotStyle: SxProps<Theme> = {
        fontSize: "24px",
        color: 'var(--text-black)',
        lineHeight: "57px",
        fontWeight: 700,
        fontFamily: 'var(--font-title)',
        marginTop: "-10px"
    };

    

    let roundImage: string = "#F4F4F4";
    let roundLogo: string = "#F4F4F4";
    let mixMaxFlex: string = "Flex";
    let number: string = "8x";    
    let borderRadius: string = "12px";
    let borderImageSource: string = "linear-gradient(180deg, #F37B35 0%, rgba(243, 123, 53, 0) 100%)";
    let topHeight: string = "140px";
    let border: string = "double 1px transparent";
    let boxShadow: string = "rgba(0, 0, 0, 0.2) 0px 3px 3px -2px, rgba(0, 0, 0, 0.14) 0px 3px 4px 0px, rgba(0, 0, 0, 0.12) 0px 1px 8px 0px";
    let boxPadding: string = "1px";
    let widthBox: string = "340px";
    let minMaxFlexTextColor: string = 'var(--text-white)';
    let numberImage: string = "";
    let numberBackgroundHeight: string = "64px";
    let numberBackgroundWidth: string = "77px";
    let borderRadiusTop: string = "";
    let textTitle: string = 'var(--font-color-supportive)';
    let fontWeight: number | string = 400;
    let fontFamily: string = 'var(--font-title)';
    let fontFamilyJackpot: string = 'var(--font-title)';
    let numberIcon: ReactNode = "";
    let borderBottom: string = "";

    if (round.name.indexOf("Max") > -1) {                
        mixMaxFlex = "Max";
        number = "13x";
        borderImageSource = "linear-gradient(180deg, #F3BA27 0%, rgba(0, 0, 0, 0) 100%)";
    }

    if (round.name.indexOf("Mix") > -1) {                
        mixMaxFlex = "Mix";
        number = "12x";
        borderImageSource = "linear-gradient(180deg, #93B9DE 0%, rgba(0, 0, 0, 0) 100%)";
    }

    roundImage = `url(${roundImage})`;
    roundLogo = `url(${roundLogo})`;

    number = GetFlexNumber(round.name);
    
    if (theme === themeC.Orange) {

        const isLight = IsOrangeLight(theme);
        roundImage = "linear-gradient( 0deg, var(--background_4) 100%, var(--background_4) 100%)";
        roundLogo = gradientsC.Orange.Flex;
        mixMaxFlex = round.name.indexOf("Hockey") > -1 ? productNamesC.Orange.Hockey : productNamesC.Orange.Flex;        
        borderRadius = "8px";
        borderRadiusTop = "8px 8px 0px 0px";
        borderImageSource = "none";
        border = isLight ? "1px solid #EBEBEB" : "1px solid #575757";
        boxPadding = "0px";
        widthBox = "320px";
        topHeight = "72px";
        boxShadow = "0px 1px 13px -2px rgba(16, 24, 40, 0.08)";
        smallText = { ...smallText, color: isLight ? '#636363' : '#B3B3B3' };
        smallTitle = { ...smallTitle, color: isLight ? '#1F1F1F' : '#F0F0F0', fontSize: '18px', fontWeight: 400, lineHeight: '24px' };
        smallTitleUpper = { ...smallTitleUpper, color: isLight ? '#1F1F1F' : '#F0F0F0', fontSize: '16px', fontWeight: 700, lineHeight: '24px', textTransform: 'uppercase' };
        jackpotStyle = { ...jackpotStyle, fontSize: '24px', fontWeight: 700, color: isLight ? '#1F1F1F' : '#F0F0F0', lineHeight: '32px', marginTop: '4px' };

        if (round.name.indexOf("Max") > -1) {
            mixMaxFlex = productNamesC.Orange.Max;
            number = "13";
            roundLogo = gradientsC.Orange.Max;
        }

        if (round.name.indexOf("Mix") > -1) {
            mixMaxFlex = productNamesC.Orange.Mix;
            number = "12";
            roundLogo = gradientsC.Orange.Mix;
        }
    }

    if (theme === themeC.GoGo) {

        roundImage = "linear-gradient(90deg, #1E1E1E 0%, #1E1E1E 100%)";
        roundLogo = gradientsC.GoGo.Flex;
        mixMaxFlex = round.name.indexOf("Hockey") > -1 ? productNamesC.Orange.Hockey : productNamesC.Orange.Flex;        
        borderRadius = "8px";
        borderRadiusTop = "8px 8px 0px 0px";
        borderImageSource = "none";
        border = "1px solid #575757";
        boxPadding = "0px";
        widthBox = "276px";
        topHeight = "72px";
        boxShadow = "0px 1px 13px -2px rgba(16, 24, 40, 0.08)";
        textTitle = '#B3B3B3';
        smallText = { ...smallText, color: 'var(--font-color-supportive)' };
        smallTitle = { ...smallTitle, color: '#F0F0F0', fontSize: '18px', fontWeight: 400, lineHeight: '24px' };
        smallTitleUpper = { ...smallTitleUpper, color: '#F0F0F0', fontSize: '18px', fontWeight: 400, lineHeight: '24px', textTransform: 'none' };
        jackpotStyle = { ...jackpotStyle, fontSize: '24px', fontWeight: 700, color: '#F0F0F0', lineHeight: '32px', marginTop: '4px' };

        if (round.name.indexOf("Max") > -1) {
            mixMaxFlex = productNamesC.Orange.Max;
            number = "13";
            roundLogo = gradientsC.GoGo.Max;
        }

        if (round.name.indexOf("Mix") > -1) {
            mixMaxFlex = productNamesC.Orange.Mix;
            number = "12";
            roundLogo = gradientsC.GoGo.Mix;
        }
    }

    if (window.theme === themeC.Wood) {

        roundImage = "linear-gradient(90deg, #1E1E1E 0%, #1E1E1E 100%)";
        roundLogo = gradientsC.Wood.Flex;
        mixMaxFlex = round.name.indexOf("Hockey") > -1 ? productNamesC.Orange.Hockey : productNamesC.Orange.Flex;        
        borderRadius = "8px";
        borderRadiusTop = "8px 8px 0px 0px";
        borderImageSource = "none";
        border = "1px solid #575757";
        boxPadding = "0px";
        widthBox = "320px";
        topHeight = "72px";
        boxShadow = "0px 1px 13px -2px rgba(16, 24, 40, 0.08)";
        textTitle = '#B3B3B3';
        smallText = { ...smallText, color: '#B3B3B3', fontFamily: "'GT-America'" };
        smallTitle = { ...smallTitle, color: '#F0F0F0', fontSize: '18px', fontWeight: 500, lineHeight: '24px', fontFamily: "'GT-America'" };
        smallTitleUpper = { ...smallTitleUpper, color: '#F0F0F0', fontSize: '18px', fontWeight: 500, lineHeight: '24px', textTransform: 'none', fontFamily: "'GT-America'" };
        jackpotStyle = { ...jackpotStyle, fontSize: '24px', fontWeight: 700, color: '#F0F0F0', lineHeight: '32px', marginTop: '4px', fontFamily: "'GT-America'" };

        if (round.name.indexOf("Max") > -1) {
            mixMaxFlex = productNamesC.Orange.Max;
            number = "13";
            roundLogo = gradientsC.Wood.Max;
        }

        if (round.name.indexOf("Mix") > -1) {
            mixMaxFlex = productNamesC.Orange.Mix;
            number = "12";
            roundLogo = gradientsC.Wood.Mix;
        }
    }

    if (window.theme === themeC.Lion) {
        roundImage = "linear-gradient( 0deg, var(--background_4) 100%, var(--background_4) 100%)";
        roundLogo = gradientsC.Lion.Flex;
        mixMaxFlex = round.name.indexOf("Hockey") > -1 ? productNamesC.Orange.Hockey : productNamesC.Orange.Flex;        
        borderRadius = "8px";
        borderRadiusTop = "8px 8px 0px 0px";
        borderImageSource = "none";
        border = "1px solid #EBEBEB";
        boxPadding = "0px";
        widthBox = "320px";
        topHeight = "72px";
        boxShadow = "0px 1px 13px -2px rgba(16, 24, 40, 0.08)";
        smallText = { ...smallText, color: '#636363', lineHeight: '20px' };
        smallTitle = { ...smallTitle, color: '#1F1F1F', fontSize: '18px', fontWeight: 400, lineHeight: '24px' };
        smallTitleUpper = { 
            ...smallTitleUpper, 
            fontFamily: 'Roboto',
            fontStyle: 'normal',
            fontWeight: 400,
            fontSize: '18px',
            lineHeight: '24px',
            display: 'flex',
            alignItems: 'center',
            textAlign: 'center',
            color: '#1F1F1F',
            flex: 'none',
            order: 1,
            flexGrow: 0,
            textTransform: 'uppercase' 
        };
        jackpotStyle = { ...jackpotStyle, fontSize: '24px', fontWeight: 700, color: '#1F1F1F', lineHeight: '32px', marginTop: '4px' };

        if (round.name.indexOf("Max") > -1) {
            mixMaxFlex = productNamesC.Orange.Max;
            number = "13";
            roundLogo = gradientsC.Lion.Max;
        }

        if (round.name.indexOf("Mix") > -1) {
            mixMaxFlex = productNamesC.Orange.Mix;
            number = "12";
            roundLogo = gradientsC.Lion.Mix;
        }
    }

    if (theme === themeC.Green) {

        const isHockey = round.name.indexOf("Hockey") > -1;
        roundImage = "linear-gradient( 0deg, var(--background_4) 100%, var(--background_4) 100%)";
        roundLogo = isHockey ? `url(${unibet_hockey})` : `url(${unibet_football})`;
        mixMaxFlex = isHockey ? "Hockey" : "Rätt";        
        borderRadius = "4px";
        borderRadiusTop = "4px 4px 0px 0px";
        borderImageSource = "none";
        widthBox = "300px";
        boxShadow = "0px 1px 3px 0px #00000040";
        logoSize = isHockey ? '110% auto' : '160% auto';
        if (isHockey) logoPosition = '-28px -73px';
        if (!isHockey) logoPosition = 'center 64%';
        topHeight = '140px';
        mixMaxFlexStyle = { ...mixMaxFlexStyle, fontFamily: 'UnibetPro' };
        mixMaxFlexNumberStyle = { ...mixMaxFlexNumberStyle, fontFamily: 'UnibetPro' };

        if (round.name.indexOf("Max") > -1) {
            mixMaxFlex = isHockey ? "Hockey" : "Rätt";
            number = "13";
        }

        if (round.name.indexOf("Mix") > -1) {
            mixMaxFlex = isHockey ? "Hockey" : "Rätt";
            number = "12";
        }
    }

    if (theme === themeC.Hajper) {

        smallTitleUpper = { ...smallTitleUpper, textTransform: 'none' };

        roundImage = "linear-gradient(308.65deg, #091137 3.32%, #11226E 62.17%)";
        roundLogo = `url(${hajper8})`;
        mixMaxFlex = "";        
        borderRadius = "12px";
        borderRadiusTop = "12px 12px 0px 0px";
        borderImageSource = "none";
        widthBox = "300px";
        boxShadow = "0px 1px 3px 0px #00000040";
        mixMaxFlexStyle = { ...mixMaxFlexStyle, fontFamily: 'HajperDisplay' };
        mixMaxFlexNumberStyle = { ...mixMaxFlexNumberStyle, fontFamily: 'HajperDisplay', marginTop: "-10px", fontSize: "90px" };
        border = "1px solid #2640C3";

        if (round.name.indexOf("Max") > -1) {
            number = "13";
            roundLogo = `url(${hajper13})`;
        }

        if (round.name.indexOf("Mix") > -1) {
            number = "12";
            roundLogo = `url(${hajper12})`;
        }
    }

    if (theme === themeC.Snabbare) {

        smallTitleUpper = { ...smallTitleUpper, textTransform: 'none' };
        logoSize = 'contain';
        topHeight = '124px';

        roundImage = "linear-gradient( 0deg, var(--background_4) 100%, var(--background_4) 100%)";
        roundLogo = `url(${snabbare8})`;
        mixMaxFlex = "";
        number = "";        
        borderRadius = "12px";
        borderRadiusTop = "12px 12px 0px 0px";
        borderImageSource = "none";
        widthBox = "300px";
        boxShadow = "0px 1px 3px 0px #00000040";

        if (round.name.indexOf("7") > -1) {
            roundLogo = `url(${snabbare7})`;
        }
        if (round.name.indexOf("9") > -1) {
            roundLogo = `url(${snabbare9})`;
        }
        if (round.name.indexOf("Max") > -1) {
            roundLogo = `url(${snabbare13})`;
        }

        if (round.name.indexOf("Mix") > -1) {
            roundLogo = `url(${snabbare12})`;
        }
    }

    if (theme === themeC.Reviant) {
        smallTitleUpper = { ...smallTitleUpper, textTransform: 'none' };
        mixMaxFlexStyle = { ...mixMaxFlexStyle, color: '#E71F00' };
        mixMaxFlexNumberStyle = { ...mixMaxFlexNumberStyle, color: '#E71F00' };
        logoSize = 'cover';
        topHeight = '124px';
        roundImage = "linear-gradient( 0deg, var(--background_4) 100%, var(--background_4) 100%)";
        roundLogo = `url(${reviantBg})`;
        mixMaxFlex = productNamesC.ComeOn.Flex;
        borderRadius = "12px";
        borderRadiusTop = "12px 12px 0px 0px";
        borderImageSource = "none";
        border = "0.666667px solid rgba(0, 0, 0, 0.1)";
        widthBox = "300px";
        boxShadow = "none";
        boxPadding = "0px";

        if (round.name.indexOf("Max") > -1) {
            mixMaxFlex = productNamesC.ComeOn.Max;
            number = "13";
        }
        if (round.name.indexOf("Mix") > -1) {
            mixMaxFlex = productNamesC.ComeOn.Mix;
            number = "12";
        }
    }

    if (theme === themeC.Stugan) {

        logoSize = 'contain';
        topHeight = '124px';
        smallTitleUpper = { ...smallTitleUpper, textTransform: 'none' };
        mixMaxFlexStyle = { ...mixMaxFlexStyle, fontWeight: "800" };
        roundImage = "linear-gradient( 0deg, var(--background_4) 100%, var(--background_4) 100%)";
        roundLogo = `url(${stugan8})`;
        mixMaxFlex = "";
        number = "";        
        borderRadius = "12px";
        borderRadiusTop = "12px 12px 0px 0px";
        borderImageSource = "none";
        widthBox = "300px";
        boxShadow = "0px 1px 3px 0px #00000040";
        borderBottom = "0.666667px solid rgb(232, 234, 236)";

        if (round.name.indexOf("9") > -1) {
            roundLogo = `url(${stugan9})`;
        }

        if (round.name.indexOf("7") > -1) {
            roundLogo = `url(${stugan7})`;
        }

        if (round.name.indexOf("Max") > -1) {
            roundLogo = `url(${stugan13})`;
        }

        if (round.name.indexOf("Mix") > -1) {
            roundLogo = `url(${stugan12})`;
        }
    }

    if (theme === themeC.Kryss) {
        smallText = { ...smallText, fontFamily: 'var(--font-body)' };
        fontFamilyJackpot = 'var(--font-body)';
        mixMaxFlexStyle = { ...mixMaxFlexStyle, fontWeight: "800" };
        roundImage = "linear-gradient( 0deg, var(--background_4) 100%, var(--background_4) 100%)";
        roundLogo = gradientsC.Kryss.Flex;
        mixMaxFlex = round.name.indexOf("Hockey") > -1 ? productNamesC.Paf.Hockey : productNamesC.Paf.Flex;        
        borderRadius = "12px";
        borderRadiusTop = "12px 12px 0px 0px";
        borderImageSource = "none";
        widthBox = "300px";
        boxShadow = "0px 1px 3px 0px #00000040";
        borderBottom = "0.666667px solid rgb(232, 234, 236)";

        if (round.name.indexOf("Max") > -1) {
            mixMaxFlex = productNamesC.Paf.Max;
            number = "13";
            roundLogo = gradientsC.Kryss.Max;
        }

        if (round.name.indexOf("Mix") > -1) {
            mixMaxFlex = productNamesC.Paf.Mix;
            number = "12";
            roundLogo = gradientsC.Kryss.Mix;
        }
    }

    if (theme === themeC.Hard) {
        smallText = { ...smallText, fontFamily: 'var(--font-body)' };
        fontFamilyJackpot = 'var(--font-body)';
        smallTitle = { ...smallTitle, color: 'var(--text-white)' };
        smallTitleUpper = { ...smallTitleUpper, color: 'var(--text-white)', textTransform: 'none' };
        jackpotStyle = { ...jackpotStyle, color: 'var(--button-color)' };
        roundImage = "linear-gradient( 0deg, var(--background_4) 100%, var(--background_4) 100%)";
        roundLogo = round.name.indexOf("Hockey") > -1 ? `url(${hard9})` : `url(${hard8})`;        
        borderRadius = "12px";
        borderRadiusTop = "12px 12px 0px 0px";
        borderImageSource = "none";
        widthBox = "300px";
        boxShadow = "0px 1px 3px 0px #00000040";
        mixMaxFlex = "";
        number = "";


        if (round.name.indexOf("Max") > -1) {
            roundLogo = `url(${hard13})`;
        }

        if (round.name.indexOf("Mix") > -1) {
            roundLogo = `url(${hard12})`;
        }
    }


    if (theme === themeC.Lyllo) {

        smallTitleUpper = { ...smallTitleUpper, textTransform: 'none' };
        mixMaxFlexStyle = { ...mixMaxFlexStyle, fontWeight: "800" };

        roundImage = "linear-gradient( 0deg, var(--background_4) 100%, var(--background_4) 100%)";
        roundLogo = gradientsC.Lyllo.Flex;
        mixMaxFlex = round.name.indexOf("Hockey") > -1 ? productNamesC.ComeOn.Hockey : productNamesC.ComeOn.Flex;        
        borderRadius = "12px";
        borderRadiusTop = "12px 12px 0px 0px";
        borderImageSource = "none";
        widthBox = "300px";
        boxShadow = "0px 1px 3px 0px #00000040";
        borderBottom = "0.666667px solid rgb(232, 234, 236)";

        if (round.name.indexOf("Max") > -1) {
            mixMaxFlex = productNamesC.ComeOn.Max;
            number = "13";
            roundLogo = gradientsC.Lyllo.Max;
        }

        if (round.name.indexOf("Mix") > -1) {
            mixMaxFlex = productNamesC.ComeOn.Mix;
            number = "12";
            roundLogo = gradientsC.Lyllo.Mix;
        }
    }

    if (theme === themeC.ComeOn) {

        smallTitleUpper = { ...smallTitleUpper, textTransform: 'none' };
        logoSize = 'contain';
        topHeight = '124px';

        roundImage = "linear-gradient( 0deg, var(--background_4) 100%, var(--background_4) 100%)";
        roundLogo = `url(${comeon8})`;
        mixMaxFlex = "";
        number = "";        
        borderRadius = "12px";
        borderRadiusTop = "12px 12px 0px 0px";
        borderImageSource = "none";
        widthBox = "300px";
        boxShadow = "0px 1px 3px 0px #00000040";
        mixMaxFlexStyle = { ...mixMaxFlexStyle, fontFamily: 'Gravity' };
        mixMaxFlexNumberStyle = { ...mixMaxFlexNumberStyle, fontFamily: 'Gravity' };

        if (round.name.indexOf("7") > -1) {
            roundLogo = `url(${comeon7})`;
        }
        if (round.name.indexOf("9") > -1) {
            roundLogo = `url(${comeon9})`;
        }
        if (round.name.indexOf("Max") > -1) {
            roundLogo = `url(${comeon13})`;
        }

        if (round.name.indexOf("Mix") > -1) {
            roundLogo = `url(${comeon12})`;
        }
    }


    if (theme === themeC.Dbet) {

        smallText = { ...smallText, fontWeight: "600" };
        smallTitle = { ...smallTitle, color: 'var(--font-title-color)' };
        smallTitleUpper = { ...smallTitleUpper, color: 'var(--font-title-color)' };

        roundImage = "linear-gradient( 0deg, var(--background_4) 100%, var(--background_4) 100%)";
        roundLogo = gradientsC.Dbet.Flex;
        mixMaxFlex = GetMixMaxFlex(round.name, window.theme);
        number = GetFlexNumber(round.name);        
        borderRadius = "10px";
        borderImageSource = "none";
        widthBox = "300px";
        minMaxFlexTextColor = "#F4C004";
        numberImage = "";
        numberBackgroundHeight = "61px";
        numberBackgroundWidth = "100px";
        topHeight = "120px";
        borderRadiusTop = "10px 10px 0px 0px";
        fontWeight = 600;
        jackpotStyle = { ...jackpotStyle, fontWeight: 900 };
        fontFamily = "Righteous";
        numberIcon =
            <Grid container direction="row" alignItems="center" >
                <Grid sx={{ marginRight: "10px", paddingLeft: "25px" }}>
                    {DbetEightIcon()}
                </Grid>
                {DbetEightLadder()}
            </Grid>

        if (round.name.indexOf("Survivor6") > -1 || (round.name.indexOf("6") > -1 && round.name.indexOf("Survivor") > -1)) {
            numberIcon =
                <Grid container direction="row" alignItems="center" >
                    <Grid sx={{ marginRight: "10px", paddingLeft: "25px" }}>
                        {DbetSixIcon()}
                    </Grid>
                    {DbetEightLadder()}
                </Grid>
        }
        if (round.name.indexOf("Hockey7") > -1) {
            numberIcon =
                <Grid container direction="row" alignItems="center" >
                    <Grid sx={{ marginRight: "7px", paddingLeft: "18px" }}>
                        {DbetSevenIcon()}
                    </Grid>
                    {DbetEightLadder()}
                </Grid>
        }
        if (round.name.indexOf("Hockey9") > -1) {
            mixMaxFlex = "";
            numberBackgroundHeight = "100px";
            numberBackgroundWidth = "262px";
            numberIcon =
                <Grid container alignItems="center" justifyContent="center" sx={{ height: "100%" }}>
                    {DbetHockeyNineLogo(30, 262)}
                </Grid>
        }

        if (round.name.indexOf("Max") > -1) {
            number = "13";
            roundLogo = gradientsC.Dbet.Max;
            numberBackgroundHeight = "64px";
            numberBackgroundWidth = "130px";
            numberIcon =
                <Grid container direction="row" alignItems="center" >
                    <Grid sx={{ marginRight: "10px", paddingLeft: "25px" }}>
                        {DbetThirteenIcon()}
                    </Grid>
                    {DbetThirteenLadder()}
                </Grid>
        }

        if (round.name.indexOf("Mix") > -1) {
            number = "12";
            roundLogo = gradientsC.Dbet.Mix;
            numberBackgroundHeight = "62px";
            numberBackgroundWidth = "130px";
            numberIcon =
                <Grid container direction="row" alignItems="center" >
                    <Grid sx={{ marginRight: "10px", paddingLeft: "25px" }}>
                        {DbetTwelveIcon()}
                    </Grid>
                    {DbetTwelveLadder()}
                </Grid>
        }

        numberImage = `url(${numberImage})`;
    }

    if (theme === themeC.Video) {

        smallText = { ...smallText, fontWeight: "600" };
        smallTitle = { ...smallTitle, color: 'var(--font-title-color)' };
        smallTitleUpper = { ...smallTitleUpper, color: 'var(--font-title-color)' };

        roundImage = "linear-gradient( 0deg, var(--background_4) 100%, var(--background_4) 100%)";
        roundLogo = `url(${video8})`;
        mixMaxFlex = GetMixMaxFlex(round.name, window.theme);        
        borderRadius = "10px";
        borderImageSource = "none";
        widthBox = "300px";
        minMaxFlexTextColor = "#7EFFB2";
        topHeight = "130px";
        borderRadiusTop = "10px 10px 0px 0px";
        fontWeight = 600;
        jackpotStyle = { ...jackpotStyle, fontWeight: 900 };
        fontFamily = "Tilt Warp";

        if (round.name.indexOf("Max") > -1) {
            roundLogo = `url(${video13})`;
            minMaxFlexTextColor = "#FFF3B7";
        }

        if (round.name.indexOf("Mix") > -1) {
            roundLogo = `url(${video12})`;
            minMaxFlexTextColor = "#D47EDD";
        }
    }

    if (theme === themeC.MrVegas) {

        smallTitle = { ...smallTitle, color: 'var(--font-title-color)' };
        smallTitleUpper = { ...smallTitleUpper, color: 'var(--font-title-color)' };

        roundImage = "linear-gradient( 0deg, var(--background_4) 100%, var(--background_4) 100%)";
        roundLogo = `url(${mrvegas8})`;
        mixMaxFlex = "";        
        borderRadius = "10px";
        borderImageSource = "none";
        widthBox = "300px";
        minMaxFlexTextColor = "#7EFFB2";
        topHeight = "130px";
        borderRadiusTop = "10px 10px 0px 0px";
        fontWeight = 400;
        jackpotStyle = { ...jackpotStyle, fontWeight: 900 };

        if (round.name.indexOf("Max") > -1) {
            roundLogo = `url(${mrvegas13})`;
        }

        if (round.name.indexOf("Mix") > -1) {
            roundLogo = `url(${mrvegas12})`;
        }
    }

    if (theme === themeC.Mega) {

        smallTitleUpper = { ...smallTitleUpper, textTransform: 'none' };

        roundImage = "linear-gradient( 0deg, var(--background_4) 100%, var(--background_4) 100%)";
        roundLogo = `url(${mega8})`;
        mixMaxFlex = "";        
        borderRadius = "10px";
        borderImageSource = "none";
        widthBox = "300px";
        minMaxFlexTextColor = "#7EFFB2";
        topHeight = "130px";
        borderRadiusTop = "10px 10px 0px 0px";
        fontWeight = 400;
        jackpotStyle = { ...jackpotStyle, fontWeight: 900 };

        if (round.name.indexOf("Max") > -1) {
            roundLogo = `url(${mega13})`;
        }

        if (round.name.indexOf("Mix") > -1) {
            roundLogo = `url(${mega12})`;
        }
    }


    if (theme === themeC.Kung) {

        roundImage = "linear-gradient( 0deg, var(--background_4) 100%, var(--background_4) 100%)";
        roundLogo = gradientsC.Kung.Flex;
        mixMaxFlex = GetMixMaxFlex(round.name, window.theme);
        number = GetFlexNumber(round.name);        
        borderRadius = "10px";
        borderImageSource = "none";
        widthBox = "300px";
        minMaxFlexTextColor = "#27FFAA";
        numberImage = kung8;
        numberBackgroundHeight = "61px";
        numberBackgroundWidth = "46px";
        topHeight = "120px";
        borderRadiusTop = "10px 10px 0px 0px";

        if (round.name.indexOf("Max") > -1) {
            number = "13";
            roundLogo = gradientsC.Kung.Max;
            minMaxFlexTextColor = "#34C2FF";
            numberImage = kung13;
            numberBackgroundHeight = "64px";
            numberBackgroundWidth = "77px";
        }

        if (round.name.indexOf("Mix") > -1) {
            number = "12";
            roundLogo = gradientsC.Kung.Mix;
            minMaxFlexTextColor = "#EE8DFF";
            numberImage = kung12;
            numberBackgroundHeight = "62px";
            numberBackgroundWidth = "77px";
        }

        numberImage = `url(${numberImage})`;
    }

    if (round.name.indexOf("Survivor") > -1) {
        mixMaxFlex = (window as any).theme === themeC.Green ? 'Stegen' : (theme === themeC.Hajper ? '' : t('survivor8'));
        number = GetFlexNumber(round.name);
    }

    const isSurvivor = round.name.toLowerCase().indexOf("survivor") !== -1;

    // Survivor-specific overrides for GoGo theme
    if (isSurvivor && theme === themeC.GoGo) {
        roundImage = "linear-gradient(135.71deg, #1E1E1E 46.63%, #575757 100%)";
        roundLogo = "linear-gradient(90deg, rgba(37, 37, 37, 0.76) 0%, rgba(37, 37, 37, 0.24) 100%), linear-gradient(0deg, #F14AA7, #F14AA7)";
        borderRadiusTop = "8px 8px 0px 0px";
        border = "none";
        boxPadding = "0px";
        smallText = { ...smallText, color: '#B3B3B3', fontSize: '14px', lineHeight: '20px', fontWeight: 400, textAlign: 'center' };
        smallTitle = { ...smallTitle, color: '#F0F0F0', fontSize: '18px', fontWeight: 400, lineHeight: '24px', textAlign: 'center' };
        smallTitleUpper = { ...smallTitleUpper, color: '#F0F0F0', fontSize: '18px', fontWeight: 400, lineHeight: '24px', textAlign: 'center' };
        jackpotStyle = {
            ...jackpotStyle,
            fontSize: '24px',
            fontWeight: 700,
            lineHeight: '32px',
            marginTop: '4px',
            background: 'linear-gradient(90deg, #B79734 27.36%, #DDB95F 31.51%, #DDB95F 52.71%, #FDEDAC 57.09%, #DDB95F 61.93%, #B79734 75.29%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
        };
    }

    // Survivor-specific overrides for Wood theme
    if (isSurvivor && theme === themeC.Wood) {
        roundImage = "linear-gradient(135.71deg, #1E1E1E 46.63%, #575757 100%)";
        roundLogo = `url(${woodRocket})`;
        logoSize = "100% auto";
        logoPosition = "right bottom";
        borderRadiusTop = "8px 8px 0px 0px";
        border = "none";
        boxPadding = "0px";
        smallText = { ...smallText, color: '#B3B3B3', fontSize: '14px', lineHeight: '20px', fontWeight: 500, textAlign: 'center', fontFamily: "'GT-America'" };
        smallTitle = { ...smallTitle, color: '#F0F0F0', fontSize: '18px', fontWeight: 500, lineHeight: '24px', textAlign: 'center', fontFamily: "'GT-America'" };
        smallTitleUpper = { ...smallTitleUpper, color: '#F0F0F0', fontSize: '18px', fontWeight: 500, lineHeight: '24px', textAlign: 'center', fontFamily: "'GT-America'" };
        jackpotStyle = {
            ...jackpotStyle,
            fontSize: '24px',
            fontWeight: 700,
            lineHeight: '32px',
            marginTop: '4px',
            color: '#E8AC59',
            fontFamily: "'GT-America'",
        };
    }

    // Survivor-specific overrides for Orange theme (Tipsraketen)
    if (isSurvivor && theme === themeC.Orange) {
        const isLight = IsOrangeLight(theme);
        roundImage = isLight ? "linear-gradient(135.71deg, #FFF0E0 -0.16%, #FFFFFF 99.84%)" : "linear-gradient(135.71deg, #241D15 0%, #1E1E1E 55%)";
        roundLogo = `url(${orangeRocket})`;
        logoSize = "100% auto";
        logoPosition = "right bottom";
        borderRadiusTop = "8px 8px 0px 0px";
        border = "1px solid #FE8000";
        boxPadding = "0px";
        smallText = { ...smallText, color: isLight ? '#636363' : '#B3B3B3', fontSize: '14px', lineHeight: '20px', fontWeight: 400, textAlign: 'center' };
        smallTitle = { ...smallTitle, color: isLight ? '#1F1F1F' : '#F0F0F0', fontSize: '18px', fontWeight: 400, lineHeight: '24px', textAlign: 'center' };
        smallTitleUpper = { ...smallTitleUpper, color: isLight ? '#1F1F1F' : '#F0F0F0', fontSize: '16px', fontWeight: 700, lineHeight: '24px', textAlign: 'center', textTransform: 'uppercase' };
        jackpotStyle = {
            ...jackpotStyle,
            fontSize: '24px',
            fontWeight: 700,
            lineHeight: '32px',
            marginTop: '4px',
            color: isLight ? '#AC7E08' : '#E8AC59',
        };
    }

    // Survivor-specific overrides for Lion theme (Tipsraketen)
    if (isSurvivor && theme === themeC.Lion) {
        roundImage = "linear-gradient(135.71deg, #FFF3F1 -0.16%, #FFFFFF 99.84%)";
        roundLogo = `url(${lionRocket})`;
        logoSize = "100% auto";
        logoPosition = "right bottom";
        borderRadiusTop = "8px 0px 0px 0px";
        border = "1px solid #FD5C3C";
        boxPadding = "0px";
        smallText = { ...smallText, color: '#636363', fontSize: '14px', lineHeight: '20px', fontWeight: 400, textAlign: 'center' };
        smallTitle = { ...smallTitle, color: '#1F1F1F', fontSize: '18px', fontWeight: 400, lineHeight: '24px', textAlign: 'center' };
        smallTitleUpper = { 
            ...smallTitleUpper, 
            fontFamily: 'Roboto',
            fontStyle: 'normal',
            fontWeight: 400,
            fontSize: '18px',
            lineHeight: '24px',
            display: 'flex',
            alignItems: 'center',
            textAlign: 'center',
            color: '#1F1F1F',
            flex: 'none',
            order: 1,
            flexGrow: 0,
            textTransform: 'uppercase' 
        };
        jackpotStyle = {
            ...jackpotStyle,
            fontSize: '24px',
            fontWeight: 700,
            lineHeight: '32px',
            marginTop: '4px',
            color: '#BE6527',
        };
    }

    // Survivor-specific overrides for Stugan theme (Tipsraketen)
    if (isSurvivor && theme === themeC.Stugan) {
        roundLogo = `url(${round.name.indexOf("Survivor6") > -1 ? stuganSurvivor6 : stuganSurvivor8})`;
        // "Tipsraketen"/number are baked into the artwork; the generic survivor
        // block above already set these, so blank them here to avoid doubled text.
        mixMaxFlex = "";
        number = "";
    }

    // Survivor-specific overrides for Snabbare theme
    if (isSurvivor && theme === themeC.Snabbare) {
        roundLogo = `url(${round.name.indexOf("Survivor6") > -1 ? snabbareSurvivor6 : snabbareSurvivor8})`;
        // Number/label are baked into the artwork; blank them to avoid doubled text.
        mixMaxFlex = "";
        number = "";
    }

    // Survivor-specific overrides for Hard/Bethard theme (Tipsraketen).
    // One plate for Survivor6 and Survivor8: "Tipsraketen" is baked in and the
    // plate carries no round number, so blank both to avoid text over the wordmark.
    if (isSurvivor && theme === themeC.Hard) {
        roundLogo = `url(${hardSurvivor})`;
        mixMaxFlex = "";
        number = "";
    }

    const survivorTopBorderGradient = 'linear-gradient(134.7deg, #B79734 1.69%, #DDB95F 17.48%, #FDEDAC 28.15%, #DDB95F 36.05%, #B79734 47.66%, #575757 88.98%)';
    const survivorWoodBorderGradient = 'radial-gradient(100% 100% at 0% 0%, #B19661 72.6%, #1E1E1E 100%)';

    if (isTheGameRoundName(round.name) || title) {
        mixMaxFlex = title ?? t('the_game');
        number = "";
        numberImage = "";
        numberIcon = "";
    }

    // One team per row so long match names fit the tile header.
    const titleRows = title
        ? title.split(" – ").map((team, i) => <Box component="span" key={i} sx={{ display: "block", textAlign: "center" }}>{team}</Box>)
        : undefined;

    const reportSelection = () => {
        setOrigin("landing", "round_box");
        track("select_content", { content_type: "round", content_id: "round_box" });
    }

    return (

        <div onClick={() => reportSelection()}>
            <Grid sx={{
                width: widthBox,
                border: isSurvivor && (theme === themeC.GoGo || theme === themeC.Wood) ? 'none' : border,
                borderRadius: borderRadius,
                backgroundImage: isSurvivor && (theme === themeC.GoGo || theme === themeC.Wood) ? undefined : borderImageSource,
                backgroundOrigin: "border-box",
                backgroundClip: "padding-box, border-box",
                padding: isSurvivor && (theme === themeC.GoGo || theme === themeC.Wood) ? '0px' : boxPadding,
                margin: "7px",
                ...(isSurvivor && theme === themeC.GoGo ? {
                    background: survivorTopBorderGradient,
                    padding: '1px',
                } : {}),
                ...(isSurvivor && theme === themeC.Wood ? {
                    background: survivorWoodBorderGradient,
                    padding: '1px',
                } : {}),
            }}>
                <Grid container alignItems="flex-start" direction="column" sx={{
                    margin: '0px', borderRadius: isSurvivor && (theme === themeC.GoGo || theme === themeC.Wood) ? '7px' : borderRadius,
                    backgroundImage: roundImage, backgroundSize: 'cover',
                    boxShadow: boxShadow
                }}>
                    <Grid container justifyContent="center" sx={{ marginTop: "0px", marginBottom: "11px" }}>
                        <Grid item sx={{
                            width: "100%",
                            height: topHeight,
                            backgroundImage: roundLogo,
                            backgroundSize: logoSize,
                            backgroundPosition: logoPosition,
                            backgroundRepeat: 'no-repeat',
                            borderRadius: borderRadiusTop,
                            borderBottom: borderBottom
                        }}>
                            {(IsLeo(window.theme) && theme !== themeC.GoGo && theme !== themeC.Wood && theme !== themeC.Orange && theme !== themeC.Green && theme !== themeC.Lion) &&
                                <Grid direction="column" container alignItems="center" sx={{ marginTop: "-5px", marginBottom: "11px" }}>
                                    <Typography sx={mixMaxFlexStyle}>
                                        {titleRows ?? mixMaxFlex}
                                    </Typography>
                                    <Typography sx={mixMaxFlexNumberStyle}>
                                        {number}
                                    </Typography>
                                    {theme === themeC.Hajper && round.name.indexOf("Hockey") === -1 &&
                                        <Typography sx={{ fontWeight: 500, fontSize: "16px", marginTop: "-25px" }}>
                                            {isSurvivor ? t('survivor8') : 'Matcher'}
                                        </Typography>
                                    }
                                    {theme === themeC.Hajper && round.name.indexOf("Hockey") > -1 &&
                                        <Typography sx={{ fontWeight: 500, fontSize: "16px", marginTop: "-25px" }}>
                                            Hockey
                                        </Typography>
                                    }
                                </Grid>
                            }
                            {theme === themeC.Green &&
                                <Box sx={{ position: 'relative', width: '100%', height: '100%' }}>
                                    <Box sx={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', background: round.name.indexOf('Hockey') > -1 ? 'linear-gradient(0deg, rgba(14, 60, 22, 0.25) 75%, rgba(62, 171, 55, 0.125) 100%)' : 'linear-gradient(180deg, rgba(14, 60, 22, 0.5) 30%, rgba(62, 171, 55, 0.5) 100%)', borderRadius: borderRadiusTop }} />
                                    <Box sx={{ position: 'absolute', top: 8, left: 8, zIndex: 1 }}>
                                        <Unibet1x2Logo width={56} height={31} />
                                    </Box>
                                    <Box sx={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%', gap: '4px' }}>
                                        <Typography sx={{
                                            fontFamily: 'UnibetPro',
                                            fontStyle: 'normal',
                                            fontWeight: 500,
                                            fontSize: '80px',
                                            lineHeight: '60px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            textAlign: 'center',
                                            color: '#FFFFFF',
                                        }}>
                                            {number}
                                        </Typography>
                                        <Typography sx={{
                                            fontFamily: 'UnibetPro',
                                            fontWeight: 500,
                                            fontSize: '20px',
                                            lineHeight: '28px',
                                            color: '#FFFFFF',
                                            textTransform: 'uppercase',
                                        }}>
                                            {titleRows ?? mixMaxFlex}
                                        </Typography>
                                    </Box>
                                </Box>
                            }
                            {IsVideo(window.theme) &&
                                <Grid direction="column" container alignItems="center" sx={{ marginTop: "-5px", marginBottom: "11px" }}>
                                    <Typography sx={{
                                        fontSize: "20px",
                                        fontFamily: fontFamily,
                                        color: minMaxFlexTextColor,
                                        fontWeight: (window.theme === themeC.Dbet || window.theme === themeC.Video) ? "400" : "700",
                                        textTransform: (window.theme === themeC.Video) ? "none" : "uppercase",
                                        marginTop: "10px",
                                        marginBottom: "5px"
                                    }}>
                                        {titleRows ?? mixMaxFlex}
                                    </Typography>
                                    <Box
                                        sx={{
                                            backgroundImage: numberImage,
                                            backgroundSize: "contain",
                                            backgroundRepeat: "no-repeat",
                                            height: numberBackgroundHeight,
                                            width: numberBackgroundWidth,
                                        }}
                                    >
                                        {numberIcon}
                                    </Box>

                                </Grid>
                            }

                        {(theme === themeC.GoGo || theme === themeC.Wood || theme === themeC.Orange || theme === themeC.Lion) &&
                            <Grid direction="row" container alignItems="center" justifyContent="center" gap="8px" sx={{ height: "100%" }}>
                                {round.status === 'ACTIVE' && new Date(round.openTo) <= new Date(Date.now()) &&
                                    <Box sx={{
                                        backgroundColor: theme === themeC.Wood ? '#D33C2D' : theme === themeC.Orange ? '#e53935' : '#e53935',
                                        color: '#fff',
                                        borderRadius: '4px',
                                        padding: '2px 8px',
                                        fontSize: '11px',
                                        fontWeight: 700,
                                        fontFamily: theme === themeC.Wood ? "'GT-America'" : 'var(--font-title)',
                                        textTransform: 'uppercase',
                                        letterSpacing: '1px',
                                        lineHeight: '16px'
                                    }}>
                                        {t('live')}
                                    </Box>
                                }
                                <Typography sx={{
                                    fontSize: "18px",
                                    fontFamily: theme === themeC.Wood ? "'GT-America'" : 'var(--font-title)',
                                    color: (theme === themeC.Orange || theme === themeC.Lion) ? '#FFFFFF' : '#F0F0F0',
                                    fontWeight: (theme === themeC.Wood || theme === themeC.Orange || theme === themeC.Lion) ? 700 : 400,
                                    textTransform: "uppercase",
                                    lineHeight: "24px",
                                    textAlign: "center",
                                    padding: "0 12px"
                                }}>
                                    {titleRows ?? <>{mixMaxFlex} {number}</>}
                                </Typography>
                            </Grid>
                        }

                        </Grid>
                    </Grid>

                    {children ? children : (
                        <RoundBoxContent
                            round={round}                        
                            textTitle={textTitle}
                            fontWeight={fontWeight}
                            fontFamilyJackpot={fontFamilyJackpot}
                            jackpotStyle={jackpotStyle}
                            smallText={smallText}
                            smallTitle={smallTitle}
                            smallTitleUpper={smallTitleUpper}
                            theme={theme}
                            reportSelection={reportSelection}
                            t={t}
                            buttonColor={isSurvivor && theme === themeC.GoGo ? '#F14AA7' : isSurvivor && theme === themeC.Wood ? '#B19661' : undefined}
                            buttonBorderRadius={isSurvivor && (theme === themeC.GoGo || theme === themeC.Wood) ? '24px' : undefined}
                            buttonTextColor={isSurvivor && (theme === themeC.GoGo || theme === themeC.Wood) ? '#000000' : undefined}
                        />
                    )}
                </Grid>
            </Grid>

        </div>


    );
}

export default RoundBoxWithButton;
